import { defaults } from 'chart.js'
import { formatValue } from 'components_new/organisms/Widget/Types/utils'

/** Shared by the horizontal and vertical lines, so both read alike. */
export type ReferenceLine = {
  value: number
  color: string
  label?: string
}

export const PILL_H = 20
export const PADDING_X = 7
export const RADIUS = 4
export const ARROW_W = 6
export const ARROW_H = 8

export const getFont = () =>
  `600 ${defaults.font.size}px ${defaults.font.family}`

/** The label, or the value itself when the line has none. */
export const getPillText = (
  line: ReferenceLine,
  decimals?: number,
  significantFigures?: number
) => {
  const label = line.label?.trim()

  return (
    label ??
    (formatValue(
      line.value,
      null,
      decimals ?? 1,
      undefined,
      undefined,
      significantFigures
    ) as string)
  )
}
